import React, { useContext } from 'react';
import cn from 'classnames';
import { tierTypeIds } from '../../summit-program/summit';
import { UserContext } from '../WithUserState/WithUserState';
import styles from './SummitMessage.css';
import unlockIconSvg from '../../images/screener-unlock-icon.svg';

const unlockIcon = (
    <img src={unlockIconSvg} alt="unlocked icon" className="unlock icon" />
);

const dynamicSelectTierMsg = (
    <React.Fragment>
        {unlockIcon}
        <div>
            You have preferred access to closed funds because of your Summit
            Program status.
        </div>
    </React.Fragment>
);

const dynamicPsEpsTierMsg = (
    <React.Fragment>
        {unlockIcon}
        <div>
            You have preferred access to lower-cost I Class shares ($50,000
            minimum, per fund) and closed funds because of your Summit Program
            status.
        </div>
    </React.Fragment>
);

const subPageDynamicMessage = {
    [tierTypeIds.SELECT]: dynamicSelectTierMsg,
    [tierTypeIds.PERSONAL_SERVICE]: dynamicPsEpsTierMsg,
    [tierTypeIds.ENHANCED_PERSONAL_SERVICE]: dynamicPsEpsTierMsg
};

const ScreenerSummitMessage = () => {
    const { summitTier, summitTierLoaded } = useContext(UserContext) || {};

    return (
        <React.Fragment>
            {/* summit start */}
            {summitTierLoaded && (
                <div
                    className={cn('subpage-summit-notice-wrapper', {
                        loading: !summitTierLoaded
                    })}
                >
                    {subPageDynamicMessage[summitTier]}
                </div>
            )}
            <style jsx>{styles}</style>
        </React.Fragment>
    );
};

export default ScreenerSummitMessage;
